export * from './home.component';


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/home/index.ts